import { Descriptions } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { TicketTypedMetaField } from "../../../types/TicketMeta";

type Props = {
  meta: TicketTypedMetaField & { type: "select" };
};

export const MetaSelect = observer((props: Props) => {
  let displayValue = "";
  if (props.meta.multiple === true) displayValue = props.meta.value?.join(", ");
  else displayValue = props.meta.value;

  return (
    <Descriptions.Item label={props.meta.label} key={props.meta.label}>
      {displayValue}
    </Descriptions.Item>
  );
});
